import { MenuItem, TextField } from '@mui/material';
import { Styles } from 'common/types';
import { SelectOption } from 'common/ui/select-field/select-field';
import { ChangeEvent, ReactElement } from 'react';
import { UrlFilter } from '../../../../services/content-overview.service.types';

const options: Array<SelectOption> = [
  {
    title: 'ALL',
    value: UrlFilter.ALL,
  },
  {
    title: 'ASINS only',
    value: UrlFilter.WITH_ASINS,
  },
  {
    title: 'Without ASINS',
    value: UrlFilter.WITHOUT_ASINS,
  },
  {
    title: 'Failed',
    value: UrlFilter.FAILED,
  },
];

const styles: Styles = {
  select: { marginLeft: 2, width: 150, ':first-child': { marginLeft: 0 } },
};

interface Props {
  onChange: (value: number) => void;
  value: number;
}

export function UrlsFiltersSelect({ onChange, value }: Props): ReactElement {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange(parseInt(e.target.value, 10));
  };

  return (
    <TextField
      select
      color="primary"
      sx={styles.select}
      onChange={handleChange}
      value={value}
      size="small"
      label="Filters"
    >
      {options.map(option => (
        <MenuItem key={option.value} value={option.value}>
          {option.title}
        </MenuItem>
      ))}
    </TextField>
  );
}
